/* istanbul ignore file */

import React from 'react';

import { APPLICATION_SUCCESSFULLY_SUBMITTED } from 'src/components/organisms/Signup/constants/copy';
import * as styles from 'src/styles/styles';

export const ApplicationSubmitted = () => (
  <section css={styles.pageSection}>
    <h2 css={styles.finalSectionHeading}>Thank you!</h2>
    <p css={styles.finalSectionText}>{APPLICATION_SUCCESSFULLY_SUBMITTED}</p>
    <p css={styles.finalSectionText}>We will be in touch shortly.</p>
  </section>
);
